module.exports = __webpack_public_path__ + "static/media/app-logo.9be08de1.png";